import axios from "axios";

const http = axios.create({
    baseURL: process.env.BASE_API_URL
});

http.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.log(error.response.status);
        return Promise.reject(error);
    }
);
  
export default http;


// WEBPACK FOOTER //
// ./src/http/index.js